import { filter, ignoreElements, tap } from "rxjs/operators";
import { IdEventSoundCore } from "../../../utils/sound/IdEventSoundCore";
import { utilSound } from "../../../utils/sound/utilSound";
import { TypeActionAnimations, } from "../../animation/actionPelletAnimations";
export var epicSoundsPelletDrop = function (action$) {
    return action$.pipe(filter(function (action) { return action.type === TypeActionAnimations.AddPellets; }), tap(function (action) { return utilSound.event(IdEventSoundCore.ItemCollect); }), ignoreElements());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/sound/epics/epicSoundsPelletDrop.ts
// module id = 2409
// module chunks = 3